<template>
  <div>
    处理第三方登录
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      type: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    let type = this.$route.query.type
    this.handleLogin(type)
  },
  methods: {
    handleLogin(type) {
      if (type === 'qq') {
        console.log(window.location, top.location, parent.location)
        parent.opener = null
        top.opener = null
        window.close()
        top.close()
        parent.close()
        let oOpts = {
          appId: '101240358',
          redirectURI: 'https://www.zhibo.tv/index/logincallback'
        }
        window.QC.Login.showPopup(oOpts)
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
